import React, { useState } from 'react';
import { Button, Input, Label, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue, Switch, Alert, } from '@cargomatic/ui';
import { billingStatusList } from 'constants/billing-status';
import { useTranslation } from 'react-i18next';
import { showToast } from 'stores/ToastStore';
import { overrideBillingStatus, bulkOverrideOrderBillingStatus, } from 'utils/ShipmentWebAPIUtils';
import { titleize } from 'underscore.string';
import SessionStore from 'stores/SessionStore';
export function OverrideBillingStatusModal({ shipmentIds = [], orderIds = [], orderId = null, open = false, onHide, onSuccess, }) {
    const { t } = useTranslation();
    const [billingStatus, setBillingStatus] = useState('');
    const [reasonCode, setReasonCode] = useState('');
    const [pauseAutomatedEvaluations, setPauseAutomatedEvaluations] = useState(true);
    const [errors, setErrors] = useState({});
    function validate() {
        const errors = {};
        if (!billingStatus) {
            errors.billingStatus = `${t('BILLING_STATUS')} ${t('REQUIRED')}`;
        }
        if (!reasonCode && !SessionStore.isBillingStatusAdmin()) {
            errors.reasonCode = `${t('REASON_CODE')} ${t('REQUIRED')}`;
        }
        setErrors(errors);
        return errors;
    }
    async function handleSave() {
        const errors = validate();
        if (Object.keys(errors).length > 0) {
            return;
        }
        try {
            if (orderId) {
                const payload = {
                    billing_status: billingStatus,
                    pause_automated_billing_evaluation: pauseAutomatedEvaluations,
                    pause_automated_billing_evaluation_reason_code: reasonCode,
                };
                await overrideBillingStatus(payload, orderId);
            }
            else if (shipmentIds.length > 0) {
                const payload = shipmentIds.map((shipmentId) => ({
                    _id: shipmentId,
                    billing_status: billingStatus,
                    pause_automated_billing_evaluation: pauseAutomatedEvaluations,
                    pause_automated_billing_evaluation_reason_code: reasonCode,
                }));
                await overrideBillingStatus(payload);
            }
            else if (orderIds.length > 0) {
                const operations = orderIds.map((orderId) => ({
                    order_id: orderId,
                    billing_status: billingStatus,
                    pause_automated_billing_evaluation: pauseAutomatedEvaluations,
                    pause_automated_billing_evaluation_reason_code: reasonCode,
                }));
                console.log('OverrideBillingStatusModal calling bulkOverrideOrderBillingStatus', operations);
                // await bulkOverrideOrderBillingStatus(operations);
                await new Promise((resolve) => setTimeout(resolve, 650));
            }
            showToast(`${t('BILLING_STATUS')} ${t('UPDATED')}`);
            onHide();
            if (onSuccess) {
                onSuccess();
            }
        }
        catch (e) {
            showToast(`${t('BILLING_STATUS')} ${t('ERROR')}`);
            console.error(e);
        }
    }
    return (React.createElement(Dialog, { open: open, onOpenChange: onHide },
        React.createElement(DialogContent, { className: "sm:max-w-[425px]" },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, t('OVERRIDE_READY_TO_BILL_STATUS')),
                React.createElement(DialogDescription, null, t('MANUAL_OVERRIDE_READY_TO_BILL_STATUS'))),
            Object.values(errors).length > 0 && (React.createElement(Alert, null,
                t('FILL_ALL_REQUIRED_FIELDS'),
                " (*)")),
            React.createElement("div", { className: "space-y-4 py-4" },
                React.createElement("div", { className: "space-y-2" },
                    React.createElement(Label, { htmlFor: "billing-status", className: "" },
                        t('BILLING_STATUS'),
                        " *"),
                    React.createElement(Select, { value: billingStatus, onValueChange: setBillingStatus },
                        React.createElement(SelectTrigger, { className: "" },
                            React.createElement(SelectValue, { placeholder: `${t('SELECT')} ${t('BILLING_STATUS')} ` })),
                        React.createElement(SelectContent, null,
                            React.createElement(SelectGroup, null,
                                React.createElement(SelectLabel, null, t('BILLING_STATUS')),
                                billingStatusList.map((status) => (React.createElement(SelectItem, { value: status, key: status }, titleize(t(status.toUpperCase()))))))))),
                React.createElement("div", { className: "space-y-2" },
                    React.createElement(Label, { htmlFor: "reason-code", className: "" },
                        t('REASON_CODE'),
                        " *"),
                    React.createElement(Input, { id: "reason-code", value: reasonCode, onChange: (e) => setReasonCode(e.target.value), placeholder: "Provide a reason", className: "w-full" })),
                React.createElement("div", { className: "flex items-center space-x-2" },
                    React.createElement(Switch, { id: "pause-automated-evaluations", checked: pauseAutomatedEvaluations, onCheckedChange: setPauseAutomatedEvaluations }),
                    React.createElement(Label, { htmlFor: "pause-automated-evaluations" }, t('PAUSE_AUTOMATED_EVALUATIONS')))),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { type: "submit", onClick: handleSave }, t('SAVE'))))));
}
